import {
    GdprActionTypeEnumApi,
    GdprConsentsQueryApi,
    GdprOrderTypeEnumApi,
    useGdprConsentsByEmailQueryApi,
    useGdprConsentsQueryApi,
} from 'graphql/generated';
import { useQueryError } from 'hooks/graphQl/UseQueryError';

export const useGdprConsents = (
    action: GdprActionTypeEnumApi,
    orderType: GdprOrderTypeEnumApi | null,
): GdprConsentsQueryApi['gdprConsents'] | undefined => {
    const [{ data, error }] = useGdprConsentsQueryApi({
        variables: { action, orderType },
        requestPolicy: 'cache-and-network',
    });
    useQueryError(error);

    return data?.gdprConsents;
};

export const useGdprConsentsByEmail = (
    action: GdprActionTypeEnumApi,
    orderType: GdprOrderTypeEnumApi | null,
    email: string,
): GdprConsentsQueryApi['gdprConsents'] | undefined => {
    const [{ data, error }] = useGdprConsentsByEmailQueryApi({
        variables: { action, orderType, email },
        requestPolicy: 'cache-and-network',
        pause: email === '',
    });
    useQueryError(error);

    return data?.gdprConsentsByEmail;
};
